import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

const Equipment = () => {
  return (
    <section className="py-20 bg-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center"
          >
            <h2 className="text-3xl font-extrabold mb-6">Moderne Ausstattung für höchste Effizienz</h2>
            <p className="text-slate-300 text-lg mb-12">
              Unser umfangreicher und moderner Maschinen- und Fuhrpark ermöglicht es uns, mehrere parallele Großbaustellen flexibel und termingerecht zu bedienen.
            </p>
            
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 text-left">
              <div className="bg-slate-800 p-5 rounded-xl border border-slate-700">
                <SafeIcon name="Tool" className="h-8 w-8 text-amber-500 mb-3" />
                <h4 className="font-bold text-lg mb-1">Maschinenpark NE3</h4>
                <p className="text-slate-400 text-sm">7 Bagger, 4 LKW, Grabenfräse, Trommelanhänger, Fugenschneider uvm.</p>
              </div>
              <div className="bg-slate-800 p-5 rounded-xl border border-slate-700">
                <SafeIcon name="Activity" className="h-8 w-8 text-amber-500 mb-3" />
                <h4 className="font-bold text-lg mb-1">Ausstattung NE4</h4>
                <p className="text-slate-400 text-sm">16 Firmenfahrzeuge, modernste Glasfaser-Spleißgeräte & Messequipment.</p>
              </div>
            </div>
          </motion.div>

        </div>
      </div>
    </section>
  );
};

export default Equipment;